import { useCallback, useRef, useState } from 'react';

const DEFAULT_MOVE_THRESHOLD_PX = 10;

export function useTapToggle(moveThresholdPx = DEFAULT_MOVE_THRESHOLD_PX) {
  const [open, setOpen] = useState(false);
  const pointerStartRef = useRef<{ x: number; y: number } | null>(null);

  const onPointerDown = useCallback((event: React.PointerEvent<HTMLButtonElement>) => {
    event.preventDefault();
    pointerStartRef.current = { x: event.clientX, y: event.clientY };
  }, []);

  const onPointerUp = useCallback(
    (event: React.PointerEvent<HTMLButtonElement>) => {
      const start = pointerStartRef.current;
      pointerStartRef.current = null;
      if (!start) return;

      const movedX = Math.abs(event.clientX - start.x);
      const movedY = Math.abs(event.clientY - start.y);
      if (movedX <= moveThresholdPx && movedY <= moveThresholdPx) {
        setOpen((current) => !current);
      }
    },
    [moveThresholdPx],
  );

  const onPointerCancel = useCallback(() => {
    pointerStartRef.current = null;
  }, []);

  const onClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  }, []);

  return {
    open,
    setOpen,
    triggerProps: {
      onPointerDown,
      onPointerUp,
      onPointerCancel,
      onClick,
    },
  };
}
